import { render, staticRenderFns } from "./undermaintenance.vue?vue&type=template&id=886dbe06&"
import script from "./undermaintenance.vue?vue&type=script&lang=js&"
export * from "./undermaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports